import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerService } from './service/spinner-service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class SpinnerComponent {
  private readonly spinner = inject(SpinnerService);
  isLoading$ = this.spinner.isLoading$;
  constructor() {}
}
